export default "__VITE_ASSET__Ds4D96p4__"